import { createTripArrayFieldMachine } from './createTripArrayFieldMachine';

export const passengerAssistanceMachine = createTripArrayFieldMachine(
  'passengerAssistance',
);
